import React, { useState, useEffect } from "react";
import { CopilotKit } from "@copilotkit/react-core";
import { CopilotPopup } from "@copilotkit/react-ui";
import "@copilotkit/react-ui/styles.css";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  // Use the Vercel serverless function endpoint (same domain, so just use relative path)
  const runtimeUrl = process.env.REACT_APP_COPILOTKIT_RUNTIME_URL || "/api/copilotkit";

  return (
    <CopilotKit runtimeUrl={runtimeUrl}>
      <Router>
        <Preloader load={load} />
        <div className="App" id={load ? "no-scroll" : "scroll"}>
          <Navbar />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="*" element={<Navigate to="/"/>} />
          </Routes>
          <Footer />
        </div>
        <CopilotPopup
          instructions="You are Portfolion AI, a helpful assistant for Jordan Martens' portfolio website. You can answer questions about Jordan's skills, work experience, projects, and resume. Be friendly, concise, and helpful. If asked about topics unrelated to the portfolio, politely redirect the conversation back to relevant topics."
          labels={{
            title: "Portfolion AI",
            initial: "Hi! I'm Portfolion AI. Ask me anything about Jordan's skills, experience, or projects!",
          }}
        />
      </Router>
    </CopilotKit>
  );
}

export default App;
